module.exports = __webpack_public_path__ + "static/media/y-function.503a17eb.svg";